export const ORDER_DIRECTION = {
    ASC: 1,
    DESC: 2
}

export const DEFAULT_PAGE_SIZE = 10;